//英文
export default {
  Login: {
    Title: "Log in to your account",
    describe: "Please log in or create an account to get started.",
    Google: " Continue with Google",
    Apple: " Continue with Apple",
    or: "OR",
    Emailplaceholder: "Email address",
    Passwordplaceholder: "Password",
    Login: "Log in",
    forgot: "Forgot password?",
    notAccount: "Don't have a Fineshare account? ",
    Signup: "Sign up",
    InvalidEmail: "Invalid email format.",
    InvalidPassword: "Password should be at least 6 characters long.",
    loading: "loading..",
    login: "login",
    errorText: "Login failed, please check your username and password",
  },
  signup: {
    Title: "Create Your Account",
    describe: "Create your Fineshare account in seconds.",
    Google: " Sign up with Google",
    Apple: " Sign up with Apple",
    or: "OR",
    Emailplaceholder: "Enter email address",
    Passwordplaceholder: "Enter a 6-digit password",
    Already: "Already have an account? ",
    Login: "Log in",
    By: "By creating an account, I agree that I have read and accepted the",
    Privacy: "Privacy Policy",
    Terms: "Terms of Use.",
    and: "and",
    signupText: "Create your account",
    InvalidEmail: "Invalid email format.",
    InvalidPassword: "Password should be at least 6 characters long.",
    loading: "loading..",
    passwordError: "The email address has been registered",
    again: "You are asking too much, please try again later",
    Registration: "Registration failed, please check your email and password.",
    hasRegistered: "The email address has been registered",
    Title2: "Create Your Fineshare Account",
  },
  Home: {
    Welcome: "Welcome to the Fineshare Account Center",
    Hi: "Hi,",
    Order: "My Order",
    orders: "View our purchase orders",
    Learn: "Learn More",
    Product: "Mange Product",
    products: "View my purchased products",
    Setting: "Account Setting",
    Settings: "Account details and change your password",
    account: "Get the most out of your account",
    FineCam: "FineCam",
    FineCams: "Create & Share Your Inspiring Videos Anywhere",
    FineVoice: "FineVoice",
    FineVoices: "Create Voiceovers with Your Favorite Voices, Your Way",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Transform Your Voice, Transmit Your Emotions",
    Singify: "Singify",
    Singifys: "Create AI Covers with Your Desired Voices",
  },
  success: {
    Congratulations: "Congratulations!",
    successfully: "Your Fineshare account has been created successfully. ",
  },
  successapp: {
    Successful: "Successful Login!",
    successfully1:
      "You have successfully logged into your Fineshare account and you can now start using the app.",
    successfully2:
      "You have successfully logged into your Fineshare account. You may close this window now and start using the app.",
    Go: "Go to Fineshare User Center",
  },
  forgot: {
    ForgotPas: " Forgot password? ",
    Enter1: "Enter the reset password email",
    Enter2:
      "Enter your email address and we'll send you a link to reset your password.",
    exmple: "{email}",
    Back: "Back log in",
    submitText: "Submit",
    errorText: "Please enter your email address",
    loading: "loading...",
    sent: "We have sent an email to your email address",
    notExist: "Your email does not exist, please confirm your email",
    Reset: "Reset failed, please confirm your email",
  },
  account: {
    Settings: "Account Settings",
    Change: "Change your account details, passwords and more.",
    Personal: "Personal Information",
    email: "E-mail:",
    Name: "User Name:",
    Edit: "Edit",
    title: "Change username",
    message: "The entered name cannot be empty.",
    placeholder: "Please enter your username",
    Reset: "Reset Password",
    Resets:
      "You can reset your password, please enter 6 or more numbers and password",
    ResetPas: "Reset Password",
    Delete: "Delete Account",
    Deletes:
      "This will permanently delete your account and all of its data, and you will not be able to reactivate this account.",
    sure: "Are you sure you want to delete your Fineshare account?",
    sures:
      "Once your account is deleted, all your data on Fineshare will be permanently removed. To proceed with account deletion, we have sent a verification code to you. Please enter the code and click Confirm.",
    Deletebtn: "Delete",
    Deleteplaceholder: "Please enter the 6-digit verification code",
  },
  order: {
    Order: "My Order",
    history: "Your order history has been recorded on this page",
    dont: "You don't have a product yet",
    Buy: "Buy now to get more optimization, click the button below to get it now",
    BuyBtn: "Buy Now",
    OrderId: "Order Id:",
    Price: "Price:",
    Date: "Order Date:",
  },
  Product: {
    Product: "My Product",
    products: "The products logged into your account",
    dont: "You don't have a product yet",
    Management: "Management Devices >",
  },
  redeem: {
    Redeem: "Redeem Membership",
    products: "Here you can redeem Fineshare products",
    Please: "Please enter your redemption code",
    placeholder: "Redemption code",
    Submit: "Submit",
    Notes: "Notes:",
    Notes1: "1.Redemption code format: XXXXX;",
    Notes2: `2.To view your redeemed products, please click on the "Product" menu. `,
    Successfully: "Successfully Redeemed",
    Follow: "Follow the steps below to start using VoiceTrans:",
    step1: "1. Download and install Fineshare VoiceTrans.",
    step2: "2. Open VoiceTrans and go to ",
    Account: "Account",
    step3:
      "3. Enter your email and password to sign in to your Fineshare account.",
    Tips: "Tips: For better use, please read the ",
    guide: "guide",
    Redemption: "Redemption Failed",
    redeemed:
      "The redemption code has been redeemed. Please open the software and log in to your account again to start using it.",
    Failed: "Redemption Failed",
    check: "Please check your redemption code.",
  },
  details: {
    Product: "My Product",
    products: "All products you have purchased are on this page",
    Back: "Back List",
    Name: "Device Name",
    system: "Device system",
    status: "Device status",
    Operation: "Operation",
    Delete: "Delete",
    contact:
      "Direct removal is not currently supported, if you need to remove the device, please contact us at ",
  },
  nav: {
    Home: "Home",
    Account: "Account",
    Order: "Order",
    Product: "Product",
    Redeem: "Redeem",
    Help: " Help center",
  },
  auth: {
    Authorization: "Authorization succeeded!",
    wait: "Going back to the application, please wait...",
  },
  notfound: {
    Not: "Page Not Found",
    Unfortunately:
      "Unfortunately, the page you are looking for does not exist, or there is an error in the link you entered.",
    Home: "Go to Home",
  },
  topuser: {
    Settings: "Account Settings",
    language: "language",
    Logout: "Logout",
  },
  loginweb: {
    Conversion: "Conversion is about to start",
    currently: "There are currently ",
    people: " people in the queue!",
    Please:
      "Please log in, and we'll send you the results to your email after the conversion is completed.",
    dont: "I don't want to log in",
  },
  mobilelogin: {
    Welcome: "Welcome to Fineshare! Please sign in to get started.",
  },
  reset: {
    Reset: "Reset a new password",
    Password:
      "Password requires at least 6 characters, containing at least 1 letter and 1 number.",
    password: "Enter your new password",
    Back: "Back log in",
    Congratulations: "Congratulations!",
    successfully: "Password reset successfully, start logging in immediately",
    Login: "Login",
    Please: "Please enter 6 digits and letters",
    failed: "Password reset failed, please click the reset link in the mailbox",
  },
  verification: {
    verification: "Enter the verification code",
    haveverification: "We have sent a verification code to ",
    Please: ". Please enter the verification code you received below:",
    Enter: "Enter the 6-digit verification code",
    Resend: "Resend verification code",
    Wait: "Wait ",
    again: " seconds and send again",
    Verify: "Verify",
    error: "Verification code error",
    verificationcode: "Please enter the verification code",
  },
};
